<select *ngIf="currentPeriod && periods"
        [(ngModel)]="currentPeriod"
        (change)="onPeriodChange($event.target.value)">
    <option *ngFor="let period of periods" [value]="period">
        <kiwi-period [period]="period"></kiwi-period>
    </option>
</select>
